module.exports = __webpack_public_path__ + "img/20200611_150535.228d9d84.jpg";